import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import josa from 'josa-js'
import ToggleButton from 'vue-js-toggle-button'
import VeeValidate, { Validator } from 'vee-validate'
import ko from 'vee-validate/dist/locale/ko'
import {currency, currencyNum, currencyWon, currencyKor, thousand} from './filter.js'
import VueResize from 'vue-resize'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css';
import PortalVue from "portal-vue";
Vue.use(PortalVue);

import ProgressBar from 'vuejs-progress-bar'
Vue.use(ProgressBar)

import VueHead from 'vue-head'
Vue.use(VueHead)

import VModal from 'vue-js-modal'
Vue.use(VModal,{ componentName: "modal" })

// import AdminTable from '../src/components/module/admin/AdminTable'
// import AdminFilter from '../src/components/module/admin/AdminFilter'
// Vue.component('AdminTable', AdminTable)
// Vue.component('AdminFilter', AdminFilter)

import AdminDatePicker from '../src/components/module/admin/AdminDatePicker'
Vue.component('AdminDatePicker', AdminDatePicker)

import BlockForms from '../src/components/page/estimate/form/component/BlockForms'
Vue.component('BlockForms', BlockForms)

import LpEditor from '../src/components/module/common/LpEditor';
Vue.component('LpEditor', LpEditor)

//모달//
let modalComponents = require.context('@/components/module/modal', false, /Modal[A-Z].*\.vue/);
modalComponents.keys().forEach(filename => {
  let componentConfig = modalComponents(filename);
  componentConfig = componentConfig.default || componentConfig;
  let componentName = componentConfig.name || (
    filename.replace(/^.+\//, '').replace(/\.\w+$/, '')
  );
  Vue.component(componentName, componentConfig);
});

//////
import moment from 'moment'
moment.locale('ko');  // moment 한국어 설정
Vue.prototype.moment = moment;

import DatePicker from 'vue2-datepicker'
Vue.component('DatePicker', DatePicker)

import VueTimepicker from 'vue2-timepicker'
Vue.component('VueTimepicker', VueTimepicker)

import { Sketch } from 'vue-color'
Vue.component('color-picker', Sketch)

import AdminBoxItem from '../src/components/module/admin/AdminBoxItem'
Vue.component('AdminBoxItem', AdminBoxItem)
import AdminFormItem from '../src/components/module/admin/AdminFormItem'
import html2canvas from "html2canvas";
Vue.component('AdminFormItem', AdminFormItem)

require('./assets/sass/main.scss');

require(`./assets/css/lp_main.styl`)

// require(`./assets/css/bulma.min.css`)     // 0.7.1
//require(`./assets/css/reset.styl`)
//require(`./assets/css/lp_variable.styl`)
require(`./assets/css/lp_fonts.styl`)
require(`./assets/css/slick.styl`)
require('./assets/css/suneditor.min.css')

require('string-format-js')

Vue.filter('currency', currency)
Vue.filter('currencyNum', currencyNum)
Vue.filter('currencyWon', currencyWon)
Vue.filter('currencyKor', currencyKor)
Vue.filter('thousand', thousand)
Vue.prototype.currency = currency;
Vue.prototype.currencyWon = currencyWon;
Vue.prototype.currencyNum = currencyNum;
Vue.prototype.currencyKor = currencyKor;
Vue.prototype.thousand = thousand;

Vue.use(VueResize)
Vue.use(VeeValidate);
Validator.localize('ko', ko);

Vue.use(ToggleButton)
Vue.use(VCalendar, {
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['L', 'YYYY-MM-DD', 'YYYY/MM/DD'],
    dayPopover: 'L',
  }
})

Vue.prototype.$axios = axios;

Vue.mixin(
  {
    activated() {
      // 이전 페이지에서 push로 들어온 경우, 현재 경로가 alivePage 목록에 있는 경우 getData, init 함수 호출
      if(this.$route.meta.isRefresh) {
        // console.log('test')
        if(this.init) {
          this.init();
        }

        /*if(this.getDataFromServer) {
          this.getDataFromServer();
        }*/
      }
    },
    computed: {
      serviceType() {
        let service_type = 4;
        if(this.$store.getters.serviceType) service_type = this.$store.getters.serviceType;
        return service_type;
      },
      serviceInfo() {
        return this.$store.getters.masterServiceInfo;
      },
      stopAdmin() {
        let bool = false;
        let service = this.$store.getters.masterServiceInfo;
        if(service && service.status===10) bool = true;
        // return false;
        return bool;
      },
      isLaunchpack() {
        return (location.origin.indexOf('superadmin')>-1 ||
            this.$store.getters.getPackages.find(i => i.name === 'launchpack'));
      },
      isMasterAdmin() {
        return (this.$store.getters.admin.username === 'launchpack');
      },
      isAdmin() {
        if (location.href.indexOf('/admin') > -1)
          return true;
        else if (location.href.indexOf('/partner') > -1)
          return false;
      },

      param_group_id() {
        return this.$route.params.group_id ? parseInt(this.$route.params.group_id) : '';
      },

      backendUrl() {
        if (process.env.VUE_APP_LP_BACKEND_URL) {
          return process.env.VUE_APP_LP_BACKEND_URL;
        }
        const {
          protocol,
          host,
        } = document.location;
        return `${protocol}//${host}/api`;
      },

      masterBackendUrl() {
        return process.env.NODE_ENV === 'production' ? 'https://master-dev.launchpack.co.kr:1111/' : 'http://localhost:8001/'
      },
      modalStatus() {
        return this.$store.state.modalStatus;
      },
      modalResponse() {
        return this.$store.state.modalResponse;
      },
    },
    methods: {
      saveServiceGuide(id) {
        if(!id) return;
        this.$axios.post('admin/service/guide/save', {
          id: id
        })
      },
      checkServiceVersion(ver) {
        return this.$store.getters.serviceVersion >= ver;
      },
      getRatio (type) {
        let brand = this.$store.getters.brand;
        if(brand.image_rates_field) {
          let data = find(brand.image_rates_field, 'type', type);
          if (data) return `이미지 비율은 ${data.ratio} 을 권장합니다.`;
        }
        else return ''
      },
      // 내부 플러그인
      isInternalPlugin(plugin_name) {
        let plugin = this.$store.getters.getInternalPlugin;
        if(plugin.length>0) return this.$store.getters.getInternalPlugin.indexOf(plugin_name) !== -1;
        else return false;
        // return this.$store.getters.getInternalPlugin;
      },
      onKeyDown(item, event){
        // console.log(item, event)
        // click control
        // if(event.keyCode===17){
        //   window.open(this.backendUrl+this.$route.fullPath+'/create?id='+item.id);
        // }
      },
      validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },
      // 테마 path 들어갈 경우 theme 부분기준으로 텍스트 빼기 보류
      changePath(path){
        // 추가된 게시물일 경우 예외처리
        if(path.search('post') > -1) {
          path = path.split('?')[0];
        }

        if(path.search('mapping') > -1) {
          path = path.split('?')[0];
        }

        // theme 일경우 예외처리
        if(path.search('theme') > -1) {
          let strArr = path.split('/');
          for (let i=0; i<strArr.length; i++){
            if( strArr[i] === 'theme' && strArr.indexOf('office')>-1) {
              removeIndex(strArr, i+1);
              removeIndex(strArr, i);
              removeIndex(strArr, i-1);
              removeIndex(strArr, i-2);
            }
          }
          let fullpath = '';
          for (let j = 1; j < strArr.length; j++) {
            if(j===1) fullpath += strArr[j];
            else fullpath += '/' + strArr[j];
          }
          //console.log(fullpath);
          return fullpath;
        }
        // theme가 아니고 and office/admin
        else if(path.search('theme') === -1 && (path.search('office/admin') > -1 ||
            path.search('office/partner') > -1 || path.search('office/superpartner') > -1 || path.search('office/supervisor') > -1)) {
          let strArr1 = path.split('/');
          for (let x=0; x<strArr1.length; x++){
            if( strArr1[x] === 'admin' || strArr1[x] === 'partner' || strArr1[x] === 'superpartner' || strArr1[x] === 'supervisor') {
              removeIndex(strArr1,x);
              removeIndex(strArr1,x-1);
            }
          }
          let fullpath1 = '';
          for (let z = 1; z < strArr1.length; z++) {
            if(z===1) fullpath1 += strArr1[z];
            else fullpath1 += '/' + strArr1[z];
          }
          //console.log(fullpath);
          return fullpath1;
        }
        else return path;
      },
      // 라우팅할때 사용 ( 테마인지 / 서비스인지에 따라서 리턴 )
      getPath(name){
        let url = `/office/${this.$store.getters.mode}/`;

        if(this.$route.params.theme_key) {
          url += `theme/${this.$route.params.theme_key}/`;
        }
        else if(this.$route.params.group_id) {
          url += `group_admin/${this.$route.params.group_id}/`;
        }

        return `${url}${name}`;
      },
      getUrl(name){
        if(this.$store.getters.mode==='admin'){
          return 'admin/'+name;
        }
        else if(this.$store.getters.mode==='superpartner'){
          if (name.indexOf('superpartner/') === 0) {
            return name;
          }
          else {
            return 'superpartner/'+this.$store.getters.superpartner.user_id+ '/'+name;
          }
        }
        else if(this.$store.getters.mode==='supervisor') {
          if (name.indexOf('supervisor/') === 0) {
            return name;
          }
          else {
            return 'supervisor/'+this.$store.getters.supervisor.id+ '/'+name;
          }
        }
        else if(this.$store.getters.mode === 'space_partner') {
          console.log('name', name)
          if(name.indexOf('space/partner/')>-1) {
            return name.replace('space/partner', 'space_partner');
          }
          else if (name.indexOf('space/') <= 0) {
            return 'partner/'+this.$store.getters.partner.space_partner+ '/'+name;
          } else {
            return name.replace('space/', `space_partner/${this.$store.getters.partner.space_partner}/`);
          }
        }
        else {
          if (name.indexOf('partner/') === 0) {
            return name
          } else {
            return 'partner/'+this.$store.getters.partner.partner_id+ '/'+name;
          }
        }
      },
      cloneItem(obj) {
        if (obj === null || typeof(obj) !== 'object')
          return obj;
        var copy = obj.constructor();
        for (var attr in obj) {
          if (obj.hasOwnProperty(attr)) {
            copy[attr] = this.cloneItem(obj[attr]);
          }
        }

        return copy;
      },
      convertDate(date, type){
        if(!date) return '';
        if(type === 'date')
          return moment(date).format('YYYY-MM-DD');
        else if(type === 'datetime')
          return moment(date).format('YYYY-MM-DD HH:mm');
        else if(type === 'time')
          return moment(date).format('HH:mm');
      },
      datesFormat(dt, type) {
        if(!dt) return '';

        if(type === 'ago') {
          return moment(dt).fromNow();
        }

        let format = '';
        switch (type) {
          case 'date_time_1':
            format = 'YY년 MM월 DD일(dd) HH시 mm분'
            break;
          case 'date_time_2':
            format = 'YYYY-MM-DD HH:mm'
            break;
          case 'date_1':
            format = 'YY년 MM월 DD일(dd)'
            break;
          case 'date_2':
            format = 'YY년 MM월 DD일'
            break;
          case 'date_3':
            format = 'YYYY.MM.DD'
            break;
          case 'date_4':
            format = 'YYYY-MM-DD'
            break;
          case 'date_5':
            format = 'MM월 DD일(dd)'
            break;
          case 'date_6':
            format = 'MM.DD(dd)'
            break;
          case 'date_7':
            format = 'MM월 DD일'
            break;
          case 'date_8':
            format = 'YYYY년 MM월 DD일 dddd'
            break;
          case 'date_9':
            format = 'YY/MM/DD'
            break;
          case 'time_1':
            format = 'HH시 mm분'
            break;
          case 'time_2':
            format = 'a hh:mm';
            break;
          case 'year_1':
            format = 'YYYY'
            break;
          case 'month_1':
            format = 'MM'
            break;
          case 'day_1':
            format = 'DD'
            break;
        }
        return moment(dt).format(format);
      },
      setAuthHeader() {
        if (location.href.indexOf('/admin') > -1) {
          this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.getters.admin.token;
        } else if (location.href.indexOf('/superpartner') > -1) {
          this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.getters.superpartner.token;
        } else if (location.href.indexOf('/supervisor') > -1) {
          this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.getters.supervisor.token;
        } else {
          this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.getters.partner.token;
        }
      },
      // 패키지 이름 반환
      convertPackName(name){
        if(!name) return '';
        if(typeof name !== 'string') name = name.name;
        let pack = find(this.$store.getters.getPackages, 'name', name);
        return pack ? pack.kor_name : name === 'all' ? '전체' : '';
      },
      toast(msg) {
        this.$root.$emit('toast', msg);
      },
      toastStatus(msg) {
        this.$root.$emit('toastStatus', msg);
      },
      toastTime(msg, time) {
        if(!msg || !time) {
          return;
        }
        this.$root.$emit('toastTime', {'msg': msg,'time':time})
      },
      showProgressToast(msg, percent) {
        this.$root.$emit('showProgressToast', {msg:msg, percent:percent});
      },
      closeProgressToast() {
        this.$root.$emit('closeProgressToast')
      },
      iconPath(img) {
        return this.backendUrl + 'assets/icons/' + img;
      },
      image(img) {
        if (!img) return '';
        if (img.search('http') === -1 && img.search('base64,') === -1) {
          // console.log(img)
          return this.backendUrl + img;
        }
        else
          return img;
      },
      // 썸네일 이미지
      thumbImgField(img, width=60, height=60) {
        let url = this.image(img);
        let url_arr = url.split('.');
        if (url_arr[0].split('//')[1] === "launchpack-storage" ||
          url_arr[0].indexOf('https://launchpack-')>-1) {
          url_arr[url_arr.length - 2] = `${url_arr[url_arr.length - 2]}_thumb`;
          url = url_arr.join('.');
        }
        // this.image(img)
        return 'background-image: url('+url+');' +
          ` width: ${width}px; height: ${height}px; background-size: cover;` +
          ' background-position: center;';
      },
      // Validation check
      isValid(data, types) {
        /*
        min_length: 6,              // 최소 길이, 최대값
            max_length: 20,             // 최대 길이, 최대값
            types: this.deco.type,      // Input Type
            alpha_s: true,              // 알파벳 소문자 허용(type : text)
            alpha_g: true,              // 알파벳 대문자 허용(type : text)
            num: true,                  // 숫자 허용(type : text)
            special: true               // 특수문자 허용(type : text)
         */
        if (data.validate === undefined || data.label === '') return '';

        let msg = '';
        let patternNum = /[0-9]/;       // 숫자
        let patternC = /[a-zA-Z]/;      // 문자(대소문자)
        let patternS = /[a-z]/;         // 소문자
        let patternB = /[A-Z]/;         // 대문자
        let patternSpecial = /[~!@#$%^&*()_+|<>?:{}]/;    // 특수문자
        let patternEmail = /[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/;    //이메일

        // 빈문자 일 경우
        if (data.inputData === undefined && data.valid !== undefined && data.valid.required) {
          msg = data.label + josa.c(data.label, '을/를') + ' 입력해주세요.';
        }

        // 숫자인 경우
        else if (types === 'number' && typeof(data.inputData) === 'number') {
          if (data.inputData === 0)
            msg = data.label + josa.c(data.label, '을/를') + ' 입력해주세요.';

          else if (data.inputData < data.validate.min_length)
            msg = data.label + josa.c(data.label, '을/를') + ' 최소 %d 이상 입력해주세요.'.format(data.validate.min_length);

          else if (data.inputData > data.validate.max_length)
            msg = data.label + josa.c(data.label, '을/를') + ' 최대 %d 이하로 입력해주세요.'.format(data.validate.max_length);
        }

        // 텍스트인 경우
        else if (types === 'text' && typeof(data.inputData) === 'string') {
          if (data.inputData === '')
            msg = data.label + josa.c(data.label, '을/를') + ' 입력해주세요.';

          else if (data.inputData.length < data.validate.min_length)
            msg = data.label + josa.c(data.label, '을/를') + ' 최소 %d자 이상 입력해주세요.'.format(data.validate.min_length);

          else if (data.inputData.length > data.validate.max_length)
            msg = data.label + josa.c(data.label, '을/를') + ' 최대 %d자 이하로 입력해주세요.'.format(data.validate.max_length);

          if (msg === '') {
            let msgVal = '';
            // 소문자 사용 안함
            if (!data.validate.alpha_s && patternS.test(data.inputData))
              msgVal = '알파벳 소문자';

            // 대문자 사용 안함
            if (!data.validate.alpha_g && patternB.test(data.inputData)) {
              if (msgVal !== '') msgVal += ', ';
              msgVal += '알파벳 대문자';
            }
            // 특수문자 사용 안함
            if (!data.validate.special && patternSpecial.test(data.inputData)) {
              if (msgVal !== '') msgVal += ', ';
              msgVal += '특수문자';
            }

            // 숫자 사용 안함
            if (!data.validate.num && patternNum.test(data.inputData)) {
              if (msgVal !== '') msgVal += ', ';
              msgVal += '숫자';
            }
            if (msgVal !== '')
              msg = msgVal + '는 사용할 수 없습니다.';
          }
        }

        // email
        else if (types === 'email' && !patternEmail.test(data.inputData)) {
          msg = '올바른 이메일 형식이 아닙니다.';
        }

        // 휴대폰번호
        else if (types === 'phone' && data.inputData.length < 11) {
          msg = data.label + josa.c(data.label, '을/를') + ' 정확히 입력해주세요.';
        }

        else if (types === 'password') {
         // console.log(types)
          if (!patternC.test(data.inputData) || !patternNum.test(data.inputData) || !patternSpecial.test(data.inputData) ||
            data.inputData.length < 8) {
            msg = '비밀번호는 8자리 이상 문자, 숫자, 특수문자로 구성되어야 합니다.';
          }
        }

        return msg;
      },
      // 페이지에 맞는 판넬 값 리턴 ( 상품 페이지... )
      /*
      * pages: [
      *    { name:
      *      panel: [
      *       {
      *         enable:
      *         panel: 'panel1,
      *         name: '상품종류 판넬'
      *       }
      *      ]
      *     }
      * ]
      * */
      // 수정시
      patchData(url, params, path){
        this.$axios.patch(url, params).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            if(path){
              this.$router.replace(path);
            }
          }
        });
      },
      // 저장시
      postData(url, params, path){
        this.$axios.post(url, params).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
            if(path){
              this.$router.replace(path);
            }
          }
        });
      },

      // admin-date-picker new Date 형식 맞추기
      resetNewDate(type) {
        // 2017-01-01
        if ( type === 'start' ) {
          return new Date(2017, 0, 1);
        }
        // 현재 날짜
        else if ( type === 'end' ) {
          return new Date();
        }
      },

      // 문자열 날짜를 Date개체로 변환
      // cf. "2018-01-01" -> new Date(2018, 01, 01)
      convertNewDate(value) {
        let arr = value.split('-');
        let year = parseInt(arr[0]);
        let month = parseInt(arr[1]);
        let date = parseInt(arr[2]);
        return new Date(year, month, date);
      },

      /*  해당 함수는 param_detail에 비어있는 데이터를 추가해주기 위해 paramAllList와 비교하여 빈 데이터를 반환한다.
      *   param: 전체 파람 리스트, param_detail: 각 상세상품, 회원, 파트너의 파람
      * */
      paramChecker(paramAllList, param_detail){
        let param_data = [];
        if(paramAllList.data){
          param_data = paramAllList.data;
        }
        else {
          if(paramAllList) {
            param_data = paramAllList;
          }
        }

        if(param_data.length===0) {
          return [];
        }

        // prod_param 상품마다의 파라미터를 의미
        // param = param_list 전체 파라미터 목록
        let id_list = param_detail.map(item=>{
          return item.param_id;
        });

        let param_space = [];
        param_data.forEach(item=> {
          /* value_
          * param_id
          * param_type
          * choice_items */
          if(!id_list.includes(item.id)){
            let param = {
              param_id: item.id,
              param_type: item.param_type,
              choice_items: item.choice_items,
              name: item.name,
              format: item.format,
              options: item.options
            };
            switch(item.param_type) {
              case 0:   // text
                param.value_text = '';
                break;
              case 1:   // integer
                param.value_integer = '';
                break;
              case 2:   // float
                param.value_float = '';
                break;
              case 3:   // select
                param.value_select = [];
                break;
              case 5:   // address
                param.value_address = {
                  sido: '',
                    sigungu: '',
                    dong: '',
                    detail: '',
                    post_code: '',
                    old: '',
                    new: ''
                };
                break;
              case 6:   // linear
                param.value_linear = '';
                break;
              case 7:   // date
                param.value_date = '';
                break;
              case 8:   // date
                param.value_files = '';
                break;
              case 9:   // time
                param.value_time = '';
                break;
              case 10:   // datetime
                param.value_date_time = '';
                break;
              case 11:   // date range
                param.value_date_range = '';
                break;
              case 12:   // date time range
                param.value_date_time_range = '';
                break;
              case 13:   // date time range
                param.value_address_list = [];
                break;
              case 14:   // long text
                param.value_long_text = '';
                break;
            }
            param_space.push(param);
          }
        })
        return param_space;
      },
      /*  catArr: 선택한 카테고리보다 +1차높은 카테고리들, category_id: 선택한 카테고리 id
      *   ex) this.cat2 = this.get_cat(this.catArr2, this.category1_id);
      * */
      get_cat(catArr, category_id){
        let cat = [];
        for (let i = 0; i < catArr.length; i++) {
          if (catArr[i].parent === category_id) {
            cat.push(catArr[i]);
          }
        }
        return cat;
      },
      routerReplace(path) {
        if(this.$route.meta) {
          this.$route.meta.clickPush = true;
        }

        this.$router.replace(path);
      },
      routerPush(path) {
        if(this.$route.meta) {
          this.$route.meta.clickPush = true;
        }

        this.$router.push(path);
      },
      async printOrder(elementRef) {
        // elementRef.style.marginLeft = '120px'
        // elementRef.style.marginRight = '120px'
        let el_order_detail = document.getElementById('orderDetailPage');
        let content = el_order_detail.getElementsByClassName('flex-content');
        let label = el_order_detail.getElementsByClassName('label');
        for(let c_item of content) {
          c_item.style.fontSize = '16px';
        }
        for(let l_item of label) {
          l_item.style.fontSize = '16px';
        }

        elementRef.style.width = '1000px'
        let html = document.getElementsByTagName('html')[0]

        // style 추가
        let style = document.createElement('style')
        style.innerText = '* { box-shadow: none !important }'
        html.appendChild(style)

        let appMain = document.getElementsByClassName('app-main')[0]
        appMain.style.marginLeft = '0px'

        let canvas = await html2canvas(elementRef, { allowTaint : true });

        // head 삭제
        let head = html.children[0]
        let copy_head = head
        html.removeChild(head)

        // edge 삭제
        let edge = document.getElementById('edge')
        let copy_edge = edge
        let body = document.getElementsByTagName('body')[0]
        body.removeChild(edge)

        let app = document.getElementById('app')
        let printDiv = document.createElement('DIV')
        printDiv.style.textAlign = 'center'
        document.body.appendChild(printDiv)
        printDiv.appendChild(canvas)


        app.style.display = 'none'

        setTimeout(() => {
          window.print()
          // elementRef.style.marginLeft = 0
          // elementRef.style.marginRight = 0
          let el_order_detail = document.getElementById('orderDetailPage');
          let content = el_order_detail.getElementsByClassName('flex-content');
          let label = el_order_detail.getElementsByClassName('label');
          for(let c_item of content) {
            c_item.style.fontSize = '0.9rem';
          }
          for(let l_item of label) {
            l_item.style.fontSize = '0.9rem';
          }

          elementRef.style.removeProperty("width")
          app.style.display = 'block'

          appMain.style.marginLeft = '240px'

          document.body.removeChild(printDiv);

          // edge 추가
          body.appendChild(copy_edge, 0);

          // head 추가
          html.insertBefore(copy_head, html.firstChild)

          html.removeChild(style)
        }, 500)
      },
      svgSrc(icon) {
        if(this.isLaunchpack) {
          return `/static/icon/${icon}.svg`;
        }
        else if(process.env.NODE_ENV==='production') {
          return `/office/static/icon/${icon}.svg`;
        } else return `/static/icon/${icon}.svg`;
      },
      imgSrc(image) {
        if(this.isLaunchpack) {
          return `/static/image/${image}.png`;
        }
        else if(process.env.NODE_ENV==='production') {
          return `/office/static/image/${image}.png`;
        } else return `/static/image/${image}.png`;
      }
    }
  }
)

new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  components: {App},
})
